<script setup lang="ts">
import ScreeningReviewActions from "@/components/recruitment/screening/review/ScreeningReviewActions.vue";
import ScreeningReviewAiSummary from "@/components/recruitment/screening/review/ScreeningReviewAiSummary.vue";
import ScreeningReviewDocuments from "@/components/recruitment/screening/review/ScreeningReviewDocuments.vue";
import ScreeningReviewIdentity from "@/components/recruitment/screening/review/ScreeningReviewIdentity.vue";

defineProps<{
  /** No decision bar: the sheet of a candidate shared in the chat */
  hideActions?: boolean;
}>();

const emits = defineEmits<{
  openComments: [];
  updateStatus: [status: number];
  rejectWithReason: [categoryId: string | null];
  openRejectionModal: [];
  openRecontactDate: [];
  openEditCandidateInformations: [];
  openDocumentViewer: [file: { filePath: string; fileType: string }, fileName: string];
  openSendMail: [];
}>();

const application = defineModel<any>({ required: true });
</script>

<template>
  <article
    class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden"
    :data-cy="`candidate-review-${application.candidate._id}`"
  >
    <ScreeningReviewAiSummary v-model="application" class="mb-2" />
    <div
      class="grid min-h-0 flex-1 grid-cols-1 grid-rows-[auto_minmax(0,1fr)] gap-3 xl:grid-cols-[17.5rem_minmax(0,1fr)] xl:grid-rows-1"
    >
      <ScreeningReviewIdentity
        v-model="application"
        class="min-h-0 min-w-0 overflow-x-hidden overflow-y-auto xl:border-r xl:border-base xl:pr-3"
        @open-comments="emits('openComments')"
        @open-edit-candidate-informations="emits('openEditCandidateInformations')"
      />
      <ScreeningReviewDocuments
        v-model="application"
        class="min-h-0 min-w-0"
        @open-document-viewer="(file, fileName) => emits('openDocumentViewer', file, fileName)"
      />
    </div>

    <div v-if="!hideActions" class="mt-2 flex shrink-0 items-center gap-2 border-t border-base pt-2 pr-24">
      <slot name="before-actions" />
      <ScreeningReviewActions
        v-model="application"
        @update-status="emits('updateStatus', $event)"
        @reject-with-reason="emits('rejectWithReason', $event)"
        @open-rejection-modal="emits('openRejectionModal')"
        @open-recontact-date="emits('openRecontactDate')"
        @open-send-mail="emits('openSendMail')"
      />
      <slot name="after-actions" />
    </div>
  </article>
</template>
